module.exports = __webpack_public_path__ + "static/media/16.7829777a.png";